export default __webpack_public_path__ + "static/Banner-9a089dda0b53c41c40a5f90feee733e1.jpg";